<template>
  <v-container fluid fill-height>
    <v-layout row wrap max>
      <v-flex xs12 text-xs-center v-if="this.$store.state.settings.extranet !== true">
        <h2 class="white--text">Добро пожаловать!</h2>
        <v-flex text-xs-center mt-3>
          <v-btn to="/login">Войти</v-btn>
          <v-btn color="primary" to="/register">Регистрация</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {};
</script>
